/**
 * Format an amount in öre (cents) to a localized currency string.
 * @param amountOre Amount in öre (e.g., 15000 = 150 kr)
 * @param currency ISO currency code (default: 'SEK')
 * @returns Formatted string like "150,00 kr"
 */
export function formatMoney(amountOre: number | null | undefined, currency = 'SEK'): string {
  if (amountOre == null) return '—';
  const value = amountOre / 100;
  return new Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency,
  }).format(value);
}

/**
 * Format an amount in öre to a whole-number currency string (no decimals).
 * @param amountOre Amount in öre (e.g., 25000 = "250 kr")
 * @param currency ISO currency code (default: 'SEK')
 */
export function formatMoneyWhole(amountOre: number | null | undefined, currency = 'SEK'): string {
  if (amountOre == null) return '—';
  const value = amountOre / 100;
  return new Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

/**
 * Format price for display (Swedish format)
 * @param amount Amount in kronor (not öre)
 * @param currencyCode ISO currency code (default: 'SEK')
 */
export function formatPrice(amount: number, currencyCode: string = 'SEK'): string {
  return new Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}
